module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-39e39652b8a25a44f48518c4ef3e3515.jpg";